module.exports = __webpack_public_path__ + "static/media/MomentosBravectoCard6.3d3b5132.webp";